import { render, staticRenderFns } from "./parentOrderDetail.vue?vue&type=template&id=505c77f8&scoped=true&"
import script from "./parentOrderDetail.vue?vue&type=script&lang=js&"
export * from "./parentOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./parentOrderDetail.vue?vue&type=style&index=0&id=505c77f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c77f8",
  null
  
)

export default component.exports